module.exports = __webpack_public_path__ + "static/assets/2360bf45fac97fab7cad8906dd516a0d.png";